import * as React from 'react';
import { DEFAULT_TABLE_PAGE_SIZE } from '../../../../../../../common/components/table/constants';
import { ITEM_TYPE_SUPPLIES } from '../../../../../../../common/config/api_constants';
import SuppliesActions from '../components/SuppliesActions';
import { getImportStatusHeaderDescription } from '../../../../../../import_data/utils/import_utils';
import { SUPPORTED_IMPORT_TYPES } from '../../../../../../import_data/constants/import_types';

const EmptyTableView = () => <p>No supplies available.</p>;

export default ({ importTypeMetadata }) => {
  return {
    dataTrackingId: 'recordId',
    dataLoadingText: 'Loading supplies',
    emptyElement: EmptyTableView, // element
    pageSize: DEFAULT_TABLE_PAGE_SIZE,
    multiSelectConfig: { selectionType: 'multi' },
    headerConfig: {
      title: 'Population',
      description: getImportStatusHeaderDescription(importTypeMetadata),
      Actions: SuppliesActions,
      importTypeMetadata,
    },
    getDataRequestBody: () => {
      return {
        itemType: ITEM_TYPE_SUPPLIES,
      };
    },
    getImportDataRequestBody: () => {
      return {
        body: {
          importTypes: SUPPORTED_IMPORT_TYPES.POPULATION_SUPPLIES,
        },
      };
    },
  };
};
